<template>
	<div class="sale-order">
		<Tab ref="tab" :tabData="tabData" @tab-click="handleClickTab" />

		<div class="scroller">
			<template v-if="tabIndex === 1">
				<nut-scroller
					:is-un-more="isUnMore"
					:is-loading="isLoading"
					:type="'vertical'"
					@loadMore="loadMoreVert"
					@pulldown="pulldown"
				>
					<div slot="list" class="nut-vert-list-panel">
						<template v-if="listData && listData.length">
							<div class="order-item" v-for="(item, index) in listData" :key="index" @click="handleClick(tabIndex,item.id)">
								<img :src="item.wx_share_img" class="picture"/>
								<ul class="flex-g-1">
									<li class="name text-ellipsis">
										{{item.title}}
									</li>
									<li class="desc overflow-2">
										{{item.wx_share_title}}
									</li>
									<li class="share">
										<a href="javascript:;"><img src="../../assets/images/fenxiang_btn.png" alt=""/></a>
									</li>
								</ul>
							</div>
						</template>
						<empty v-else></empty>
					</div>

				</nut-scroller>
			</template>
			<template v-else>
				<nut-scroller
						:is-un-more="isUnMore"
						:is-loading="isLoading"
						:type="'vertical'"
						@loadMore="loadMoreVert"
						@pulldown="pulldown"
				>
					<div slot="list" class="success-order">
						<div class="datetime header flex a-center header" @click="handleClickDate">
							{{dataValue[0]}}年{{dataValue[1]}}月<nut-icon type="down" size="10px" style="margin-left: 5px"></nut-icon>
						</div>
						<p class="total">收入￥{{income}}元</p>
						<template v-if="listData && listData.length">
							<div class="success-order-item"  v-for="(item, index) in listData" :key="index" @click="handleClick(tabIndex,item.order_id)">
								<ul class="hd flex j-between a-center">
									<li @click="copy(item.order_sn)">订单编号：{{item.order_sn}}</li>
									<li class="price">+{{item.reward_amount}}</li>
								</ul>
								<div class="bd flex a-center">
									<nut-avatar
									bg-icon
  									:bg-image="item.head_pic">
									</nut-avatar>
									<ul>
										<li>{{item.nickname}} 购买“{{item.goods_name}}”</li>
										<li>{{item.title}}</li>
									</ul>
								</div>
								<ul class="ft flex j-between">
									<li>{{item.addtime|formatItmer}}</li>
									<!--<li>余额：183.00</li>-->
								</ul>
							</div>
						</template>
						<empty v-else></empty>
					</div>
				</nut-scroller>
			</template>
		</div>
		<!-- 日期选择 -->
		<nut-picker
				class="datetimer"
				:is-visible="isVisible"
				:listData="dateListData"
				type="date"
				title="请选择日期"
				:default-value-data="defaultValueData"
				@close="isVisible = false"
				@confirm="setChooseValueCustmer"
		>
		</nut-picker>
	</div>
</template>

<script>
import Tab from '@/components/Tab'
import empty from '../Empty'
import dayjs from 'dayjs'
export default {
	name: 'sale-order',
	components: {
		Tab,empty,
	},
	data: () => ({
		time:new Date(),
		isVisible: false, // 日期
		defaultValueData:null,
		dataValue:['请选择',''],
		tabData: [
			//{label: '可推广的活动', value: 1,},
			{label: '我推广的订单', value: 2,},
		],
		tabIndex: 2,
		income:0,

		listData: [],
		isUnMore: false,
		isLoading: false,
		page: 1,
		pageSize: 15,//首次15条,以后每次10条
	}),
	filters: {
		formatItmer: function (value) {
			value = value+'000';
			let date = new Date(parseInt(value));
			let y = date.getFullYear();
			let MM = date.getMonth() + 1;
			MM = MM < 10 ? ('0' + MM) : MM;
			let d = date.getDate();
			d = d < 10 ? ('0' + d) : d;
			let h = date.getHours();
			h = h < 10 ? ('0' + h) : h;
			let m = date.getMinutes();
			m = m < 10 ? ('0' + m) : m;
			let s = date.getSeconds();
			s = s < 10 ? ('0' + s) : s;
			return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
		}
	},
	computed: {
		dateListData() {
			this.defaultValueData = [new Date().getFullYear(),new Date().getMonth()+1];
			return [this.createYearGroup(), this.createMonthGroup()]
		},
	},
	created() {
		if(this.$route.query.type){
			this.tabIndex = this.$route.query.type;
		}


		this.getList();
	},
	methods: {
		createYearGroup() {
			// 当前时间往前推 10 年
			const LENGTH = 10
			const start = dayjs().year()
			return Array.from({ length: LENGTH }).map((_, index) => (start - index))
		},
		createMonthGroup() {
			const LENGTH = 12
			return Array.from({ length: LENGTH }).map((_, index) => index + 1)
		},
		handleClickDate() {
			this.isVisible = !this.isVisible
		},
		setChooseValueCustmer(chooseData){
			this.dataValue = chooseData;
			this.page = 1;
			this.pageSize = 15;
			this.listData = [];
			this.getList();

		},
		getList(){
			const ydate = this.dataValue[0] == '请选择' ? 0 : this.dataValue[0];
			const mdate = this.dataValue[1] == '' ? 0 : this.dataValue[1];
			if(this.tabIndex === 1){
				//可推广活动
				this.$ajax.get('m/wallet/can_promotion_flash', {
					pageIndex: this.page,
					pageSize: this.pageSize,
					id: this.$ajax.get_activity_id(),
				}).then(res => {
					this.isLoading = false;
					if (res && res.length) {
						this.listData = res;
						//this.listData.push(res.order_list);
						this.isUnMore = false;
						this.pageSize = 10;
						this.page++;
					} else {
						this.isUnMore = true;
					}
				})

			}else {
				//我推广的订单
				this.$ajax.get('m/wallet/distribution_log', {
					pageIndex: this.page,
					pageSize: this.pageSize,
					id: this.$ajax.get_activity_id(),
					ydate:ydate,
					mdate:mdate,
				}).then(res => {
					this.isLoading = false;
					if (res.list && res.list.length) {
						this.listData = res.list;
						//this.listData.push(res.order_list);
						this.isUnMore = false;
						this.pageSize = 10;
						this.income = res.income;
						this.page++;
					} else {
						this.income = 0;
						this.isUnMore = true;
					}
				})
			}
		},
		handleClick(tabIndex,id) {
			switch (tabIndex) {
				case 1: //活动分享
					this.$router.push({name:'ActivityShare',query:{activity_id:id}});break;
				case 2:	//订单
			}
		},
		handleClickTab(tabIndex) {
			this.page = 1;
			this.pageSize = 15;
			this.tabIndex = tabIndex;
			this.listData = [];
			this.getList();
			//this.$router.push({path:'/sale-order',query:{type:tabIndex}})
		},
		// 下拉加载更多
		pulldown() {
			this.isLoading = true
			this.pageSize = 15;
			this.page = 1;
			this.getList();
		},
		// 上拉加载更多
		loadMoreVert() {
			this.isLoading = true;
			this.getList();
		},
		copy(text){
			const input = document.createElement('input')
			document.body.appendChild(input)
			input.setAttribute('value', text)
			input.select()
			if (document.execCommand('copy')) {
				document.execCommand('copy')
				this.$toast.text('复制成功');
			}
			document.body.removeChild(input)
		},
	},
}
</script>

<style lang="less" scoped>
.sale-order {
	.nut-vert-list-panel {
		padding: 0 14px;
	}
	.scroller {
		height: calc(100vh - 40px);
	}

	.order-item {
		display: flex;
		padding: 10px 0;
		box-sizing: content-box;
		border-bottom: 1px solid #e2e2e2;
		.picture {
			flex-shrink: 0;
			width: 120px;
			height: 90px;
			border-radius: 3px;
			margin-right: 10px;
		}
		.name {
			font-size: 15px;
			color: #333333;
			font-weight: bold;
			margin-bottom: 10px;
			width: 150px;
		}
		.desc {
			font-size: 13px;
			color: #666666;
			margin-bottom: 8px;
		}
		.share {
			text-align: right;
		}
	}
	.success-order {
		height: 100%;
		overflow: scroll;
		.total {
			font-size: 11px;
			color: #999999;
			padding: 9px 14px;
		}
		.datetime {
			font-size: 15px;
			height: 40px;
			line-height: 40px;
			padding: 0 14px;
		}
		// 我推广的订单
		&-item {
			padding: 10px 14px;
			color: #333333;
			border-bottom: 1px solid #e2e2e2;
			.hd {
				font-size: 15px;
				.price {
					font-size: 16px;
					font-weight: bold;
					color: #333333;
				}
			}
			.bd {
				background-color: #f8f8f8;
				padding: 10px;
				margin: 10px 0;
				font-size: 13px;
			}
			.ft {
				font-size: 11px;
				color: #999999;
			}
		}
	}
}
.datetimer /deep/ .nut-actionsheet-panel {
	top: 0px;
	max-height: fit-content;
}
</style>
